const usedStorage = process.env.NODE_ENV === 'production' ? localStorage : sessionStorage
class Storage {
  public get(key: string) {
    const stringvalue = usedStorage.getItem(key) || ''
    // eslint-disable-next-line
    let data: string | object | any[] = stringvalue
    if (['{', '['].includes(stringvalue[0]) && [']', '}'].includes(stringvalue[stringvalue.length - 1])) {
      try {
        data = JSON.parse(data)
        // eslint-disable-next-line
      } catch {}
    }
    return data
  }

  // eslint-disable-next-line
  public set(key: string, value: any) {
    if (!key) return
    // eslint-disable-next-line
    let data: string | object | any[] = value || ''
    if (typeof data === 'object') {
      data = JSON.stringify(data)
    }
    usedStorage.setItem(key, value)
  }

  public static instance: Storage | null = null;

  public static getInstance() {
    if (!Storage.instance) {
      Storage.instance = new Storage()
    }
    return Storage.instance
  }
}

export default Storage.getInstance()
